import { useEffect } from "react";
import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.PUBLIC_GA_MEASUREMENT_ID ?? "";

export function useGoogleAnalytics(): void {
  useEffect(() => {
    if (!MEASUREMENT_ID) return;
    ReactGA.initialize(MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
}
